import { createSelector } from 'reselect';
const getPurposeLimitationsGuestState = createSelector((state) => state.purposeLimitations, purposeLimitations => purposeLimitations.guest || {
    userId: null,
    purposeLimitations: [],
    purposeLimitationsLevels: {},
    loading: false,
    error: null,
});
export default getPurposeLimitationsGuestState;
